import IFinancing from "./IFinancing";
import FinancingTypeEnum from "./FinancingTypeEnum";

export default class Financing implements IFinancing {
    constructor(public type: FinancingTypeEnum = FinancingTypeEnum.INSTALLMENT) {}
}
